import DOMPurify from "dompurify";

const SANITIZE_OPTIONS = {
  ALLOWED_TAGS: ["a", "blockquote", "br", "div", "em", "h1", "h2", "h3", "li", "mark", "ol", "p", "s", "span", "strong", "u", "ul"],
  ALLOWED_ATTR: ["href", "title", "target", "rel", "style", "class", "data-variable"],
} as const;

export function sanitizeTemplateHtml(value: string): string {
  return DOMPurify.sanitize(value, SANITIZE_OPTIONS);
}

export function templateHtmlToText(value: string): string {
  const container = document.createElement("div");
  container.innerHTML = sanitizeTemplateHtml(value).replace(/<br\s*\/?>/gi, "\n");
  container.querySelectorAll("p,div,blockquote,h1,h2,h3,li").forEach((node) => node.append("\n"));
  return (container.textContent ?? "").replace(/\n{3,}/g, "\n\n").trim();
}
